export default "__VITE_ASSET__108d7df2__"